export enum VideoPokerActionName {
    DEAL = "DEAL",
    CHANGE = "CHANGE",
    DOUBLE = "DOUBLE",
    PAYOUT = "PAYOUT",
}



// WEBPACK FOOTER //
// ./src/app/api/VideoPokerActionName.ts